import React from 'react';

const AdjustmentIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='M16 6a1 1 0 0 1 1 1v10.171a3.001 3.001 0 0 1 0 5.658V25a1 1 0 0 1-2 0v-2.17a3.001 3.001 0 0 1 0-5.66V7a1 1 0 0 1 1-1zM8 6a1 1 0 0 1 1 1v3.171a3.001 3.001 0 0 1 0 5.658V25a1 1 0 0 1-2 0v-9.17a3.001 3.001 0 0 1 0-5.66V7a1 1 0 0 1 1-1zm16 0a3 3 0 0 1 1 5.829V25a1 1 0 0 1-2 0V11.83A3.001 3.001 0 0 1 24 6zm-8 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-8-7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm16-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);

export default AdjustmentIcon;
